import * as React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import CardActionArea from '@mui/material/CardActionArea';
import CardActions from '@mui/material/CardActions';
import LocalMallIcon from '@mui/icons-material/LocalMall';
import {
  createTheme,
  ThemeProvider,
  alpha,
  getContrastRatio,
} from '@mui/material/styles';

const violetBase = '#EF7F95';
const violetMain = alpha(violetBase, 0.7);
const theme = createTheme({
  palette: {
    violet: {
      main: violetMain,
      light: alpha(violetBase, 0.5),
      dark: alpha(violetBase, 0.9),
      contrastText: getContrastRatio(violetMain, '#fff') > 4.5 ? '#fff' : '#111',
    },
  },
});

export default function MultiActionAreaCard({productInfo, onClick}) {
  return (
    <Card sx={{ maxWidth: 400 }} elevation={5}>
      <CardActionArea onClick={onClick}>
        <CardMedia
          component="img"
          image={productInfo.img_url}
          alt=""
          sx={{
            height: {sm: "auto", xs: "auto"},
            width: {sm: "100%", xs: "100%"}
          }}
        />
        <CardContent>
          <Typography gutterBottom variant="h6" component="div" sx={{ 
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            overflow: 'hidden'
          }}>
            {productInfo.title}
          </Typography>
          <Typography variant="body2" sx={{ color: 'text.secondary',
            display: '-webkit-box',
            WebkitBoxOrient: 'vertical',
            WebkitLineClamp: 4, // 限制为4行, 可能有些浏览器失效
            textOverflow: 'ellipsis',
            overflow: 'hidden' }}>
              {productInfo.briefing}
          </Typography>
        </CardContent>
      </CardActionArea>
      <CardActions sx={{justifyContent: 'space-between', alignItems: 'center'}}>
        <ThemeProvider theme={theme}>
          <Button size="medium" color='violet' startIcon={<LocalMallIcon />} onClick={onClick}>
            立即购买
          </Button>
        </ThemeProvider>
        <Typography variant="h6" component="div" color={violetMain} sx={{display: 'flex', alignItems: 'center'}}>
          ${productInfo.amount}
        </Typography>
      </CardActions>
    </Card>
  );
}
